import Card from "./Base/Card";

interface PropsI {
    pageName: string;
}

const PageName = ({ pageName }: PropsI) => {
    return (
        // <Card className="transaction-card">
        <div className="page-name-component">
            {pageName}
        </div>
        // </Card>
    )
}
export default PageName;